import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { SessionService } from '@tech-services/session.service';
import { CurrencyPipe, DoublePipe } from '@techrules/pipelib';

@Component({
  selector: 'tech-modal-tabledetail',
  templateUrl: './modal-tabledetail.component.html',
  styleUrls: ['./modal-tabledetail.component.scss'],
  /*
  animations: [
    trigger('slide', [
      state('left', style({ transform: 'translateX(0)' })),
      state('right', style({ transform: 'translateX(-50%)' })),
      transition('* => *', animate(300))
    ])
  ]*/
})
export class ModalTabledetailComponent implements OnInit {
  faChevronLeft = faChevronLeft;
  public item: any;
  public item2: any;
  public name: string;
  public nametype: string;
  public amountexecute: string;
  public ordertype: string;
  public price: string;
  public isin: string;
  public titlesexecuted: string;
  public datetrade: string;
  public dateFormats = this.sessionService.dateFormat
    .replace('DD', 'dd')
    .replace('YYYY', 'yyyy')
    .replace('MMM', 'MM');

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private currencySymbolPipe: CurrencyPipe,
    private doublePipe: DoublePipe,
    private datePipe: DatePipe,
    private sessionService: SessionService,
    private dialogRef: MatDialogRef<ModalTabledetailComponent>
  ) {
    this.item = dataDialog.item;
    this.item2 = dataDialog.item2;
  }

  ngOnInit() {
    this.dataDialog = this.item;
    this.name = this.item.ProductName;
    this.nametype = this.item2;
    this.amountexecute = this.currencySymbolPipe.transform(
      this.item.AmountExecuted,
      this.item.Currency
    );
    this.ordertype = this.item.OperationType;
    //this.datePipe.transform(now.setDate(now.getDate() - 1), 'yyyy-MM-dd');

    this.datetrade = this.datePipe.transform(
      this.item.LastDateStatus,
      this.dateFormats
    );
    this.price = this.currencySymbolPipe.transform(
      this.item.NetPriceExecuted,
      this.item.Currency
    );
    this.titlesexecuted = this.doublePipe.transform(this.item.TitlesExecuted);
    this.isin = this.item.Isin;
  }

  onClose(e) {
    document
      .getElementsByClassName('tranimate__animated')[0]
      .classList.remove('tranimate__slideInRight');
    document
      .getElementsByClassName('tranimate__animated')[0]
      .classList.add('tranimate__slideOutRight');
    setTimeout(() => {
      this.dialogRef.close(false);
    }, 1000);
  }
}
